import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { getConfig } from '@gokrew/ui/runtime-config';
import { OnboardingFeatureKey } from '@gokrew/models/company';
import { ModuleGuard } from '@/components/ModuleGuard';

/**
 * Training routes: hidden behind the `ENABLE_TRAINING` build flag until the
 * module ships (spec D119), and behind the company's module switch like
 * every optional module. A bookmarked URL goes back to the dashboard.
 */
export function TrainingGuard({ children }: { children: ReactNode }) {
  if (!getConfig().ENABLE_TRAINING) return <Navigate to="/dashboard" replace />;
  return (
    <ModuleGuard module={OnboardingFeatureKey.Training}>{children}</ModuleGuard>
  );
}
